import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { Technology } from './components/Technology';
import { Gallery } from './components/Gallery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { AdminLogin } from './components/admin/AdminLogin';
import { AdminDashboard } from './components/admin/AdminDashboard';
import { InquiryDetails } from './components/admin/InquiryDetails';
import { ProtectedRoute } from './components/admin/ProtectedRoute';
import './App.css';

// Main Website Component
const MainWebsite = () => (
  <div className="App">
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <WhyUs />
      <Technology />
      <Gallery />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <Router>
      <AdminAuthProvider>
        <Routes>
          {/* Public Website Route */}
          <Route path="/" element={<MainWebsite />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/inquiry/:inquiryId" 
            element={
              <ProtectedRoute>
                <InquiryDetails />
              </ProtectedRoute>
            } 
          />
          
          {/* Redirect /admin to /admin/dashboard */}
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          
          {/* 404 - Redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </AdminAuthProvider>
    </Router>
  );
}

export default App;
